import styled, { css } from 'styled-components';
import bgLeft from './media/bg-left.svg';
import bgRight from './media/bg-right.svg';
import bgTitle from './media/bg-title.svg';

export const BannerWrapper = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.md}) {
      margin-bottom: 15px;
      padding: 0 40px;
    }
  `}
`;

export const BannerContainer = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #124CFF 0%, #0095FF 100%);
    font-family: ${theme.v2.font.family.primary};
    overflow: hidden;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      border-radius: 8px;
    }
  `}
`;

export const BannerContainerInner = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-image: url(${bgLeft}), url(${bgRight});
    background-position: left -41px top -32px, right -90px top -36px;
    background-repeat: no-repeat;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 0 30px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      background-position: left -62px top -22px, right -87px bottom -166px;
      flex-direction: column;
      gap: 0;
      padding: 24px 0;
    }
  `}
`;

export const CollumnLeft = styled.div`
  ${({ theme }) => css`
    margin-top: auto;
    padding: 0 0 0 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      bottom: 0;
      left: 0;
      padding: 0;
      position: absolute;
    }
  `}
`;

export const CollumnCenter = styled.div`
  ${({ theme }) => css`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 8px 0 27px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 8px;
      padding: 0 0 11px;
    }

    @media (max-width: 1210px) {
      align-items: center;
    }
  `}
`;

export const CollumnRight = styled.div`
  ${({ theme }) => css`
    padding: 20px 0;
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 12px 0 0;
    }
  `}
`;

export const Snappy = styled.img`
  display: block;
`;

export const Badge = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(180deg, #7BE5A3 0%, #CDFDDD 100%);
    border-radius: 8px;
    color: ${theme.v2.colors.feedback.activeExtraDark};
    text-align: center;
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    padding: 4px 8px;
  `}
`;

export const Title = styled.div`
  ${({ theme, locale }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 22px;
    position: relative;
    text-align: center;
    
    &::before {
      background: url(${bgTitle}) no-repeat center top;
      bottom: -11px;
      content: '';
      position: absolute;
      height: 10px;
      right: 0;
      width: 170px;
    }

    @media (max-width: 1210px) {
      max-width: 265px;

      ${locale === 'es' && css`
        &::before {
          left: 50%;
          right: initial;
          transform: translateX(-50%);
        }
      `}
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      line-height: 20px;
      max-width: 235px;
    }
  `}
`;
